import React, { useRef, useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import { openSignedPdfUrl } from "src/utils/pdfSignedUrl";

const LONG_PRESS_DELAY_MS = 650;

export default function PdfActionButton({
  resourceType,
  resourceId,
  extraQueryParams = {},
  regenerateLabel = "Force Regenerate PDF",
  onOpenComplete,
  children,
  ...buttonProps
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const longPressTimerRef = useRef(null);
  const suppressClickRef = useRef(false);
  const open = Boolean(anchorEl);

  const clearLongPressTimer = () => {
    if (longPressTimerRef.current) {
      clearTimeout(longPressTimerRef.current);
      longPressTimerRef.current = null;
    }
  };

  const openPdf = (params) => {
    openSignedPdfUrl({
      resourceType,
      resourceId,
      extraQueryParams: params,
    });
    onOpenComplete?.();
  };

  const startLongPress = (event) => {
    if (buttonProps.disabled) return;

    const target = event.currentTarget;
    clearLongPressTimer();
    longPressTimerRef.current = setTimeout(() => {
      suppressClickRef.current = true;
      setAnchorEl(target);
    }, LONG_PRESS_DELAY_MS);
  };

  const handleClick = (event) => {
    if (!suppressClickRef.current) {
      openPdf(extraQueryParams);
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    suppressClickRef.current = false;
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleRegenerate = (event) => {
    event.preventDefault();
    event.stopPropagation();
    handleMenuClose();
    openPdf({ ...extraQueryParams, force_pdf_regeneration: true });
  };

  return (
    <>
      <Button
        {...buttonProps}
        onClick={handleClick}
        onMouseDown={startLongPress}
        onMouseUp={clearLongPressTimer}
        onMouseLeave={clearLongPressTimer}
        onTouchStart={startLongPress}
        onTouchEnd={clearLongPressTimer}
      >
        {children}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
        <MenuItem onClick={handleRegenerate}>{regenerateLabel}</MenuItem>
      </Menu>
    </>
  );
}
